import { FilePenLine, Trash2 } from 'lucide-react'
import { PaginationCashfit } from '../../../../components/pagination-cashfit'
import { ScrollArea } from '../../../../components/ui/scroll-area'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../../../components/ui/table'
import { formatToBRL } from '../../../../utils/formatCurrency'
import { LoadServices } from '../actions/services/load-services'
import { useState } from 'react'
import { DialogDelete } from '@/view/modals/modal-delete'
import { convertParamsToJson, useCashfitParams } from '@/view/hooks/use-params'
import { useSearchParams } from 'react-router-dom'


export function ListServices() {
  const { data, refresh } = LoadServices()
  const [params] = useSearchParams()
  const { setParams } = useCashfitParams(convertParamsToJson(params))
  const [dialogDelete, setDialogDelete] = useState(false)
  const [dataId, setDataId] = useState(0)
  const openDialogDelete = (id: number) => {
    setDataId(id)
    setDialogDelete(true)

  }

  const closeDialogDelete = () => setDialogDelete(false)

  return (
    <div className="">
      {dialogDelete && <DialogDelete
        updateList={refresh}
        closeDialog={closeDialogDelete}
        label='servicos'
        url='/servicos'
        unidade='idUnidade'
        id={dataId}
        isOpen={dialogDelete}
        unit={true}
      />}
      <ScrollArea className="h-[calc(100vh-300px)] overflow-y-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="w-[100px]">id</TableHead>
              <TableHead>nome</TableHead>
              <TableHead>descrição</TableHead>
              <TableHead className="text-right">valor</TableHead>
            </TableRow>
          </TableHeader>

          <TableBody className="">
            {data?.data.data.content.map((item: any) => (
              <TableRow key={item.id}>
                <TableCell className="font-medium">{item.id}</TableCell>
                <TableCell>{item.nome}</TableCell>
                <TableCell>{item.observacao}</TableCell>
                <TableCell className="text-right">{formatToBRL(item.valor)}</TableCell>
                <TableCell className="flex justify-center gap-1">
                  <FilePenLine
                    height={24}
                    width={30}
                    onClick={() =>
                      setParams({
                        tabServiceId: item.id,
                        tabSelected: 'create-service' as any
                      })
                    }
                    className="text-blue-500 cursor-pointer p-1 hover:text-blue-400"
                  />
                  <Trash2
                    height={24}
                    width={30}
                    onClick={() => {
                      openDialogDelete(item.id || 0)
                    }}
                    className="text-red-500 cursor-pointer p-1 hover:text-red-400"
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </ScrollArea>
      <div>
        <PaginationCashfit data={data?.data.data} labelItem="serviços" />
      </div>
    </div>
  )
}
